export default "__VITE_ASSET__DuSbOFA0__"